import { CompletionStatuses } from '../../../../constants';
import { GathererKeys } from '../../../../gatherers/allGatherers';
import { SeoRecommendationGroups } from '../../../constants';
import { GroupView } from '../../../sharedComponents/GroupView';
import { getMetaDescriptionFromArtifacts } from '../../../utils/metaTags';
import { selectAttachedCluster } from '../../data/topicEditor/slice';
import { selectSubtopics } from '../../data/topics/slice';
import { useSelector } from '../../store';
import { addHyperlinkToPillarPageAudit } from './addHyperlinkToPillarPage/addHyperlinkToPillarPageAudit';
import { AddHyperlinkToPillarPageView } from './addHyperlinkToPillarPage/AddHyperlinkToPillarPageView';
import { addTopicPhraseToMetaDescriptionAudit } from './addTopicPhraseToMetaDescription/addTopicPhraseToMetaDescriptionAudit';
import { AddTopicPhraseToMetaDescriptionView } from './addTopicPhraseToMetaDescription/AddTopicPhraseToMetaDescriptionView';
import { addTopicPhraseToTitleAudit } from './addTopicPhraseToTitle/addTopicPhraseToTitleAudit';
import { AddTopicPhraseToTitleView } from './addTopicPhraseToTitle/AddTopicPhraseToTitleView';
import { increaseClusterPhraseInBodyCountAudit } from './increaseClusterPhraseInBodyCount/increaseClusterPhraseInBodyCountAudit';
import { IncreaseClusterPhraseInBodyCountView } from './increaseClusterPhraseInBodyCount/IncreaseClusterPhraseInBodyCountView';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getTopicsRecsIncompleteCount = auditResults => {
  return auditResults.filter(auditResult => auditResult.status === CompletionStatuses.INCOMPLETE || auditResult.status === CompletionStatuses.BLOCKED).length;
};
export const TopicsRecommendationsContainer = ({
  artifacts
}) => {
  const subtopics = useSelector(selectSubtopics);
  const attachedCluster = useSelector(selectAttachedCluster);
  if (!attachedCluster) {
    return null;
  }
  const pageTitle = artifacts[GathererKeys.PAGE_TITLE];
  const links = artifacts[GathererKeys.LINKS];
  const {
    clusterPhrase,
    subtopicPhrase
  } = attachedCluster;
  const topicPhrase = subtopicPhrase || clusterPhrase;
  const metaDescription = getMetaDescriptionFromArtifacts(artifacts);
  const increaseClusterPhraseInBodyCountAuditResult = increaseClusterPhraseInBodyCountAudit(artifacts, subtopics);
  const addTopicPhraseToTitleAuditResult = addTopicPhraseToTitleAudit(pageTitle, topicPhrase);
  const addHyperlinkToPillarPageAuditResult = addHyperlinkToPillarPageAudit(links, attachedCluster);
  const addTopicPhraseToMetaDescriptionAuditResult = addTopicPhraseToMetaDescriptionAudit(metaDescription, topicPhrase);
  const auditResults = [increaseClusterPhraseInBodyCountAuditResult, addTopicPhraseToTitleAuditResult, addHyperlinkToPillarPageAuditResult, addTopicPhraseToMetaDescriptionAuditResult];
  const incompleteCount = getTopicsRecsIncompleteCount(auditResults);
  return /*#__PURE__*/_jsxs(GroupView, {
    groupType: SeoRecommendationGroups.TOPICS,
    incompleteCount: incompleteCount,
    children: [/*#__PURE__*/_jsx(AddTopicPhraseToTitleView, {
      auditResult: addTopicPhraseToTitleAuditResult
    }), /*#__PURE__*/_jsx(AddHyperlinkToPillarPageView, {
      auditResult: addHyperlinkToPillarPageAuditResult
    }), /*#__PURE__*/_jsx(AddTopicPhraseToMetaDescriptionView, {
      auditResult: addTopicPhraseToMetaDescriptionAuditResult
    }), /*#__PURE__*/_jsx(IncreaseClusterPhraseInBodyCountView, {
      auditResult: increaseClusterPhraseInBodyCountAuditResult
    })]
  });
};